import DownloadAPKButton from "./DownloadAPKButton";

export default function CtaSection() {
  return (
    <section id="download" className="section cta">
      <div className="cta-box">
        <h2 className="cta-title">
          Téléchargez SAFE (bêta) et{" "}
          <span className="neon-text">reprenez le contrôle.</span>
        </h2>
        <div className="cta-buttons">
          <DownloadAPKButton
            text="Télécharger l'APK (bêta)"
            className="btn btn-primary btn-lg"
            showIcon
          />
        </div>
      </div>
    </section>
  );
}
